import { Button, Form, Grid, Input, Select } from 'antd';
import { ContentFilters } from 'components';
import { StandardItemsWrapper } from 'components/content-filters/content-filters.styles';
import { useGetTypeList } from 'features/master/use-cases/get-type';
import { useGetRoleTypes } from 'features/users/use-cases/get-roleTypeList';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { MatrialFilterFormField, MatrialFilterFormValues } from './types';
const { useBreakpoint } = Grid;

type MatrialFilterFormProps = {
  formId: string;
  handleFilter: (values: MatrialFilterFormValues) => void;
  initialValues: MatrialFilterFormValues;
  closeModal?: () => void;
  onRefresh:() => void;
};

export const MatrialFilterForm = ({
  formId,
  handleFilter,
  initialValues,
  closeModal,
  onRefresh
}: MatrialFilterFormProps) => {
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<MatrialFilterFormValues>();
  const { t } = useTranslation();
  const { data } = useGetTypeList('' as any)
  const location=useLocation()
  
  const screens = useBreakpoint();
  const { data: roleTypeFilterList, isLoading: roleTypeFilterLoading } = useGetRoleTypes();
  const onReset = () => {
    form.resetFields();
    handleFilter(initialValues);
    onRefresh();
  };
  
  const onFinish = (formValues: MatrialFilterFormValues) => {
    handleFilter(formValues);
    closeModal?.();
  };
  if (roleTypeFilterLoading) return null;

  if (!roleTypeFilterList || !Array.isArray(roleTypeFilterList) || roleTypeFilterList.length === 0) {
    return <div>No roles available</div>;
  }


  return (
    <Form<MatrialFilterFormValues>
      id={formId}
      name={formId}
      className='filters-form'
      form={form}
      layout='vertical'
      onFinish={onFinish}
      initialValues={initialValues}
      onFinishFailed={() => {
        setValidateTrigger(['onChange']);
      }}
      validateTrigger={validateTrigger}
    >
      <ContentFilters.FormItemsWrapper className='cf_frm' style={{ width: '100%' }}>
        <StandardItemsWrapper className='cf_frm_row' style={{ width: '100%' }}>
          <div className='invoice_list' style={{ width: '100%' }}>
            <Form.Item<MatrialFilterFormValues>
              label={'Material Name'}
              name={MatrialFilterFormField.Title}
            >
              <Input
                placeholder={t('adminUsers.formFields.userName.placeholder')}
              />
            </Form.Item>
            {location?.pathname=="/master/material" &&
            <Form.Item<MatrialFilterFormValues>
              label={'Type'}
              name={MatrialFilterFormField.materialtype}
            >
              <Select
                placeholder="Select Type"
                options={data?.rc?.map((item: any) => ({
                  label: item.title, // Text displayed to the user
                  value: item.id,   // The value saved in the form
                }))}
              />
            </Form.Item>}
            {screens.lg && (
              <ContentFilters.ButtonsWrapper className='filter_btn'>
                <Button type='primary' htmlType='submit'>
                  {t('common.buttons.filter', { count: 1 })}
                </Button>
                <Button onClick={onReset}>{t('common.buttons.reset')}</Button>
              </ContentFilters.ButtonsWrapper>
            )}
          </div>
        </StandardItemsWrapper>
      </ContentFilters.FormItemsWrapper>


    </Form>
  );
};
